import React from 'react';
import { ScrollIcon, InfinityAlchemyIcon, LotusIcon, SanctuaryIcon, CompassIcon, FlameIcon } from './icons/AlchemyIcons';
import { SketchHubIcon } from './icons/SketchHubIcon';

// Portable ecosystem dock (copy-paste friendly) for sister platforms.
// - No lucide-react
// - Uses existing AlchemyIcons + a bespoke SketchHubIcon

const DockItem = ({ href, label, testId, colorClass, Icon, iconClassName = 'w-4 h-4', newTab = true }) => {
  const Wrapper = newTab ? 'a' : 'a';
  return (
    <Wrapper
      href={href}
      target={newTab ? '_blank' : undefined}
      rel={newTab ? 'noopener noreferrer' : undefined}
      className="inline-flex flex-col items-center"
      data-testid={testId}
    >
      <div className={`w-10 h-10 rounded-full border ${colorClass.border} ${colorClass.bg} flex items-center justify-center transition-colors ${colorClass.hoverBorder}`}>
        <Icon className={`${iconClassName} ${colorClass.icon}`} />
      </div>
      <div className={`mt-1 text-[9px] text-center w-10 h-[12px] leading-[12px] ${colorClass.label}`}>
        {label}
      </div>
    </Wrapper>
  );
};

export const EcosystemDock = ({ includeDefiance = true }) => {
  const colors = {
    ebook: { border: 'border-amber-500/25', bg: 'bg-amber-500/10', hoverBorder: 'group-hover:border-amber-400/50', icon: 'text-amber-400', label: 'text-amber-200/80' },
    elchme: { border: 'border-purple-500/25', bg: 'bg-purple-500/10', hoverBorder: 'group-hover:border-purple-400/50', icon: 'text-purple-400', label: 'text-purple-200/80' },
    mairy: { border: 'border-cyan-500/25', bg: 'bg-cyan-500/10', hoverBorder: 'group-hover:border-cyan-400/50', icon: 'text-cyan-400', label: 'text-cyan-200/80' },
    forge: { border: 'border-indigo-500/25', bg: 'bg-indigo-500/10', hoverBorder: 'group-hover:border-indigo-400/50', icon: 'text-indigo-400', label: 'text-indigo-200/80' },
    nvc: { border: 'border-emerald-500/25', bg: 'bg-emerald-500/10', hoverBorder: 'group-hover:border-emerald-400/50', icon: 'text-emerald-400', label: 'text-emerald-200/80' },
    sketch: { border: 'border-rose-500/25', bg: 'bg-rose-500/10', hoverBorder: 'group-hover:border-rose-400/50', icon: 'text-rose-300', label: 'text-rose-200/80' },
    defiance: { border: 'border-emerald-500/25', bg: 'bg-emerald-500/10', hoverBorder: 'group-hover:border-emerald-400/50', icon: 'text-emerald-400', label: 'text-emerald-200/80' },
  };

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap" data-testid="ecosystem-dock">
      <DockItem
        href="https://belongingsessions.com/belonging-ebook"
        label="E-book"
        testId="dock-ebook"
        Icon={ScrollIcon}
        colorClass={colors.ebook}
      />
      <DockItem
        href="https://elchme.com"
        label="ElchmE"
        testId="dock-elchme"
        Icon={InfinityAlchemyIcon}
        colorClass={colors.elchme}
      />
      <DockItem
        href="https://mairy.io"
        label="m.ai.ry"
        testId="dock-mairy"
        Icon={LotusIcon}
        colorClass={colors.mairy}
      />
      <DockItem
        href="https://blissabode.org"
        label="Forge"
        testId="dock-community-forge"
        Icon={SanctuaryIcon}
        colorClass={colors.forge}
      />
      <DockItem
        href="https://belongingsessions.com/feelings-needs"
        label="NVC"
        testId="dock-feelings-needs"
        Icon={CompassIcon}
        colorClass={colors.nvc}
      />
      <DockItem
        href="https://elchme.com/sketch"
        label="Sketch"
        testId="dock-sketch-hub"
        Icon={SketchHubIcon}
        colorClass={colors.sketch}
      />
      {includeDefiance && (
        <DockItem
          href="https://defiancesprings.com" 
          label="Defiance"
          testId="dock-defiance"
          Icon={FlameIcon}
          colorClass={colors.defiance}
        />
      )}
    </div>
  );
};
